import React from 'react';
import { X, LogOut } from 'lucide-react';
import { toast } from 'sonner';
import './premiumToast.css';

// PREMIUM-NOTIFY-001 — compact animated toast (login success / logout flow / session notices).
const Checkmark = () => (
  <span className="ptoast-icon ptoast-icon--success" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" className="ptoast-check">
      <path d="M6 12.5l4 4 8-9" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </span>
);

const Spinner = () => (
  <span className="ptoast-icon ptoast-icon--neutral" aria-hidden="true">
    <LogOut className="w-4 h-4" />
    <span className="ptoast-spinner" />
  </span>
);

export const PremiumToast = ({ variant = 'success', title, body, onClose, testId = 'premium-toast' }) => (
  <div className={`ptoast ptoast--${variant}`} role="status" aria-live="polite" data-testid={testId}>
    {variant === 'loading' ? <Spinner /> : variant === 'success' ? <Checkmark /> : (
      <span className="ptoast-icon ptoast-icon--neutral" aria-hidden="true"><LogOut className="w-4 h-4" /></span>
    )}
    <div className="ptoast-text">
      <div className="ptoast-title" data-testid={`${testId}-title`}>{title}</div>
      {body && <div className="ptoast-body">{body}</div>}
    </div>
    {onClose && (
      <button type="button" className="ptoast-close" onClick={onClose} aria-label="Dismiss notification" data-testid={`${testId}-close`}>
        <X className="w-4 h-4" />
      </button>
    )}
  </div>
);

const position = () => (typeof window !== 'undefined' && window.innerWidth < 640 ? 'top-center' : 'top-right');

export const showPremiumToast = ({ id, variant, title, body, duration = 3000, testId }) =>
  toast.custom((t) => (
    <PremiumToast variant={variant} title={title} body={body} testId={testId}
      onClose={variant === 'loading' ? undefined : () => toast.dismiss(t)} />
  ), {
    id, duration, position: position(), unstyled: true,
    // the global Toaster styles every <li>; our card carries its own chrome
    className: 'ptoast-host',
    style: { padding: 0, background: 'transparent', border: 0, boxShadow: 'none', width: 'fit-content', maxWidth: 'calc(100vw - 32px)' },
  });

export default PremiumToast;
